import { BASIC_COMPOSITION_TYPE } from "@constants";

export const getStepDetails = (stepComposition) => {
    const stepDetails = {
        selectedChoicesWithspecialPrice: 0,
        selectedChoicesWithStepPrice: 0,
    };
    for (const item of Object.values(stepComposition || {})) {
        if (item.type === BASIC_COMPOSITION_TYPE) continue;

        if (item.withSpecialPrice) {
            stepDetails.selectedChoicesWithspecialPrice += item.quantity;
        } else if (item.withStepPrice) {
            stepDetails.selectedChoicesWithStepPrice += item.quantity;
        }
    }
    return stepDetails;
};
